import styles from './Info.module.scss';
import {Link} from "../Link/Link";
import cn from "classnames";

export const Info = ({data, handler, link}) => {
    const {pics, text} = data;
    const {title, desc} = text;
    const {firstPic, firstName, secondPic, secondName} = pics;

    return (
        <div className={styles.wrapper}>
            <div className={styles.pics}>
                <div className={styles.pic}>
                    <img src={firstPic} alt={firstName}/>
                </div>
                <div className={styles.pic}>
                    <img src={secondPic} alt={secondName} className={styles.pic}/>
                </div>
            </div>
            <div className={styles.text}>
                <div className={styles.wrap}>
                    <div className={cn(styles.title, 'text-body')}>{title}</div>
                    <div className={cn(styles.desc, 'text-small')}>{desc}</div>
                    <Link tag={'div'} text={'Продолжить'} onClick={handler}/>
                </div>
            </div>
        </div>
    )
}